import axios from 'axios';
import { setupInterceptorsTo } from './legacy-api';
import { store } from 'store';
import _ from 'lodash';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

axiosInstance.interceptors.request.use(
  function (config: any) {
    const workspaces = localStorage.getItem('workspaces') || '[]';
    const sessionWorkspace = sessionStorage.getItem('workspace') || localStorage.getItem('last-active:workspace');
    const activeWorkspace = _.find(JSON.parse(workspaces), { workspace_id: sessionWorkspace });

    const externalBaseUrl = localStorage.getItem('externalBaseUrl') || '';
    // const baseUrl = localStorage.getItem('baseUrl') || process.env.REACT_APP_BASE_URL;
    const state = store.getState();
    if (state.app.external) {
      config.baseURL = externalBaseUrl;
    } else {
      config.baseURL = activeWorkspace?.url;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

const api = setupInterceptorsTo(axiosInstance);

export default api;
